<template>
  <div class="condizioni-generali">
    <div class="default-container">
      <h1>{{ $t('pageNotFound.title') }}</h1>
      <p>{{ $t('pageNotFound.content') }}</p>
    </div>
  </div>
</template>

<script>

import lang from '@/views/mixins/lang'
import store from '../store'
import { SET_GLOBAL_LOADING } from '../store/mutation-types'

export default {
  mixins: [ lang ],
  mounted: function () {
    store.commit(SET_GLOBAL_LOADING, false)
  }
}
</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";

</style>
